"use client";

import routes from "@/app.route";
import SparkleEffect from "@/components/sparkle-effect";
import { Button, useMediaQuery } from "@mui/material";
import Image from "next/image";
import Link from "next/link";

export default function Company() {
  const matches = useMediaQuery("(min-width:1024px)");

  return (
    <div className="space-y-4 md:space-y-12 py-6 md:py-12">
      <div>
        <h2 className="mb-2 text-center font-semibold text-2xl md:text-4xl">
          Company Vision
        </h2>
        <p className="text-center mb-4 md:text-base text-xs max-w-4xl mx-auto text-zinc-700 px-4">
          From intelligent drones to humanoid and companion robots, we bring
          innovation that empowers industries, creators, and communities for a
          smarter, connected future.
        </p>
        <div className="relative">
          <div className="absolute! p-4 left-1/2! -translate-x-1/2! bottom-4!">
            <SparkleEffect>
              <Button
                variant="contained"
                size="large"
                href={routes.product.url.replace(
                  ":slug",
                  "nikon-d7500-20-9mp-dslr-8-fps-4k-uhd-with-18-140mm-lens",
                )}
              >
                Buy Now
              </Button>
            </SparkleEffect>
          </div>
          {matches ? (
            <Image
              src="/images/home/Company-images.webp"
              alt="Company"
              width={1188}
              height={439}
              className="w-full"
            />
          ) : (
            <Image
              src="/images/home/Company-images-mobile.webp"
              alt="Company"
              width={588}
              height={611}
              className="w-full"
            />
          )}
        </div>
      </div>

      {/* <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-x-12 gap-y-4 md:grid-cols-2">
          <div className="md:px-0 px-4">
            <h3 className="text-2xl font-bold mb-4 md:text-4xl">
              Why choose us?
            </h3>
            <div className="mb-6 text-xs md:text-sm">
              <p className="mb-4">
                At Everse, we focus on making technology practical, reliable,
                and within your reach. Our mission is to simplify the use of
                drones and robotics for every industry and individual. We build
                tools that help you work smarter, capture better and achieve
                more with confidence. Every Everse product is tested for
                performance, safety and durability. We partner with trusted
                brands and certified manufacturers to deliver quality you can
                rely on. Whether you&apos;re using a drone for agriculture,
                surveying, security or filmmaking you can trust it to perform
                when it matters most.
              </p>
              <p>
                Our support team stays with you beyond purchase. From setup to
                maintenance, we ensure your experience remains smooth and
                worry-free. We value transparency, quick response and lasting
                relationships with every customer. Everse is committed to
                building India&apos;s future in aerial and autonomous systems.
                We aim to empower creators, professionals and industries to grow
                through technology that delivers real results. With every flight
                and every project, we&apos;re helping India move closer to
                global excellence in drones and robotics. When you choose
                Everse, you choose a team that stands behind every product we
                build.
              </p>
            </div>
            <Link
              href="https://youtu.be/kHlDcvcX0rI?si=ryrgphCBat_m60Tu"
              target="_blank"
            >
              <Image
                src="/images/home/home-yt-video.webp"
                alt="What&#39;s the BEST DJI Drone Deal for You?"
                width={640}
                height={360}
                className="w-full"
              />
            </Link>
          </div>
          <div className="order-first md:order-last">
            <Image
              src="/images/home/why-choose-us.jpg"
              alt="Image"
              width={500}
              height={600}
              className="w-full md:pl-8"
            />
          </div>
        </div>
      </div> */}

      {/* <div>
        <h4 className="text-center font-bold text-base md:text-4xl mb-2 md:mb-6 max-w-2xl mx-auto">
          Empowering India with smarter skies & intelligent machines.
        </h4>
        <div className="relative">
          <div className="absolute! p-4 left-1/2! -translate-x-1/2! bottom-4!">
            <SparkleEffect>
              <Button
                variant="contained"
                size="large"
                href={routes.product.url.replace(
                  ":slug",
                  "dji-neo-fly-more-combo",
                )}
              >
                Buy Now
              </Button>
            </SparkleEffect>
          </div>
          {matches ? (
            <Image
              src="/images/home/Impowering-india.webp"
              alt="Image"
              width={1188}
              height={349}
              className="w-full"
            />
          ) : (
            <Image
              src="/images/home/Impowering-india-mobile.webp"
              alt="Image"
              width={588}
              height={611}
              className="w-full"
            />
          )}
        </div>
      </div> */}
    </div>
  );
}
